import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useAuth } from './auth/AuthContext'

export const AdminRoute = ({component: Components, ...rest}) => {

    const { profile, loading } = useAuth()
    return (
        <Route {...rest} render={props => {
            if (loading) {
              return null
            }
            if(profile?.role === 'admin') {
              return <Components {...props} />;
            } else {
                console.log('not admin')
              return (
                <Redirect from={`${props.location}`} to='/appointment'/>
              );
            }
        }}
      />
    )
}

